<template>
  <div class="c_statistics" :class="[category_id==5 ? 'c_statistics_5' : '']" v-if="show_right">
    <div class="sta-wrap">
      <div class="sta-tab clearBoth" v-if="category_id!=5">
        <event tag="button" @click="onClick(2)" :class="{active: cur === 2}" class="normal-btn button t_btn-d">快速下注
        </event>
        <event tag="button" @click="onClick(0)" :class="{active: cur === 0}" class="normal-btn button t_btn-d">长龙排行榜
        </event>
        <event tag="button" v-if="category_id==5" @click="onClick(1)" :class="{active: cur === 1 || category_id==5}" class="normal-btn button t_btn-d">最近开奖统计
        </event>
      </div>
      <component :is="component" @fastBetF="fastBet"/>
    </div>
  </div>
</template>

<script>
  import Vue from "../../utils/bus";
  import VSTable1 from './sta-table/sta_table1'
  import VSTable2 from './sta-table/sta_table2'
  import VSTable3 from './sta-table/sta_table3'
  import {mapState} from 'vuex';

  export default {
    name: "c_statistics",
    props: {
      showRule: {
        type: Function,
        default: () => {
        }
      }
    },
    components: {
      VSTable1,
      VSTable2,
      VSTable3,
    },
    computed: {
      ...mapState({
        user: state => state.root.user
      }),
      component() {
        if(this.cur === 2){
          return 'v-s-table3';
        }else if(this.cur === 1){
          return 'v-s-table2';
        }else{
          return 'v-s-table1';
        }
      }
    },
    created() {
      Vue.$on("onTab", item => {
        if (item) {
            if(item.value<=3){
                this.show_right = true;
            }else{
                this.show_right = false;
            }
        }
      });
    },
    deactivated() {
      Vue.$off("onTab");
    },
    data() {
      return {
        cur: 2,
        category_id:0,
        show_right:true
      }
    },
    methods: {
      fastBet(arr) {
        this.$emit('onQuickCreate', arr);
      },
      onClick(tag) {
        this.cur = tag;
      },
      openRule() {
        this.$emit('showRule');
      },
    },
    mounted() {
      this.category_id = this.$route.query.category_id;
      if(this.category_id==5){
        this.onClick(1);
      }
    }
  }
</script>

<style scoped lang="stylus">
  $border-color = #e6e6e6;
  .c_statistics
    width 215px
    font-size 14px
    background-color #ffffff

    .sta_t
      width 200px
      border 1px solid $border-color
      height 32px
      box-sizing border-box
      font-weight 900
      line-height 32px
      /*padding-left 15px*/
      white-space nowrap
      text-align center

    .sta_t:hover
        background-color #e6e6e6
    span
      display inline-block
      text-align center
      vertical-align top

    span:nth-of-type(2)
      overflow hidden

    span:nth-of-type(2)
      /*width 85px*/
      /*float right*/

    .rule {
      cursor pointer
    }

    .sta-wrap

      .sta-tab
        button
          float left
          width 107.5px
          height 28px
          border 1px solid #999
          line-height 28px
  .c_statistics_5{
    margin-top: -18px;left: 705px;
  }
  @media screen and (max-width: 900px) {
  .c_statistics_5{left:calc(36vw+400px) !important;}
}
</style>



// WEBPACK FOOTER //
// src/components/c_statistics/index.vue